export const facultyCopy = {
  title: "Faculty",
  job: "Find an instructor and read their teaching assignments.",
  find: "Search faculty",
  empty: "No faculty profiles yet.",
  failed: "The faculty directory could not be read.",
  assignments: "Teaching assignments",
  noAssignments: "No teaching assignments recorded.",
  profile: "Profile",
  summary: "Teaching summary",
  notRecorded: "Not recorded",
  directory: "Directory",
  teachingDetails: "Teaching details",
  contact: "Contact and identity",
  contactNote: "Shown to students and teachers in the Faculty directory. Changing this address does not change your sign-in account.",
  directoryNote: "Shown to students and teachers in the Faculty directory.",
  contactSummary: "Contact email and honorific",
  open: "Open profile",
  teaching: "Teaching",
  unassigned: "Unassigned",
  noSpecialization: "No specialization on file",
  facts: { honorific: "Honorific", title_role: "Title", specialization: "Specialization", training_chain: "Training chain", email: "Contact email" },
};
